export function createAliPlayer(domId, source, callback, options = { auto: true, poster: '', isLive: false, rate: false }) {
    return new Aliplayer({
        id: domId,
        source,
        width: "100%",
        height: "100%",
        autoplay: options.auto,
        cover: options.poster,
        isLive: options.isLive,
        rePlay: false,
        playsinline: true,
        preload: true,
        controlBarVisibility: "hover",
        useH5Prism: true,
        skinLayout: [
            {
                "name": "bigPlayButton",
                "align": "cc",
            },
            {
                "name": "H5Loading",
                "align": "cc"
            },
            {
                "name": "errorDisplay",
                "align": "tlabs",
                "x": 0,
                "y": 0
            },
            {
                "name": "tooltip",
                "align": "blabs",
                "x": 0,
                "y": 56
            },
            {
                "name": "controlBar",
                "align": "blabs",
                "x": 0,
                "y": 0,
                "children": [
                    {
                        "name": "progress",
                        "align": "blabs",
                        "x": 0,
                        "y": 44
                    },
                    {
                        "name": "playButton",
                        "align": "tl",
                        "x": 15,
                        "y": 12
                    },
                    {
                        "name": "timeDisplay",
                        "align": "tl",
                        "x": 10,
                        "y": 7
                    },
                    {
                        "name": "fullScreenButton",
                        "align": "tr",
                        "x": 10,
                        "y": 12
                    },
                    {
                        "name": "volume",
                        "align": "tr",
                        "x": 5,
                        "y": 10
                    }
                ]
            }
        ],
        components: options.rate ? [{
            name: 'RateComponent',
            type: AliPlayerComponent.RateComponent
        }] : []
    }, function (player) {
        console.log("The player is created");
        if (callback) {
            callback()
        }
    });
}


export function dispostAliPlayer(domId, player) {
    if (player && player.dispose) {
        player.dispose()
    }
    let dom = document.getElementById(domId)
    if (dom) {
        dom.innerHTML = ''
    }
}


// WEBPACK FOOTER //
// ./src/util/aliplayer.js